/**
 * Determines if an error is related to maxUsage limits, which should show
 * a warning but not block the user from continuing with checkout.
 */
export const isMaxUsageError = (error: any): boolean => {
  const message = error?.message?.toLowerCase() || '';

  // Check for the specific maxUsage error message from backend
  return message.includes('this discount code can only be used');
};

/**
 * Determines whether checkout should be disabled based on the error type.
 * MaxUsage errors should show warnings but not block checkout.
 */
export const shouldDisableCheckoutForError = (error: any): boolean =>
  Boolean(error && !isMaxUsageError(error));
